import React from 'react';
import { MANAGE_TEACHING_ORDER_COMPONENT } from './types';

export const ManageTeachingOrderContext = React.createContext<any>(null);

export const ManageOptionsProvider = ({ children }) => {
  const [manageNavType, setManageNavType] = React.useState<MANAGE_TEACHING_ORDER_COMPONENT>(
    MANAGE_TEACHING_ORDER_COMPONENT.EditStartDate
  );

  return (
    <ManageTeachingOrderContext.Provider
      value={[{ manageNavType: manageNavType }, { setManageNavType }]}
    >
      {children}
    </ManageTeachingOrderContext.Provider>
  );
};

export const useManageOptionsProvider = () => {
  const [{ manageNavType }, { setManageNavType }] = React.useContext(ManageTeachingOrderContext);

  return [{ manageNavType }, { setManageNavType }];
};
